import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "@src/utils/baseQuery";
import { APIResponse } from "./CommonApiSlice";

interface AddModulePayload {
  name: string;
  duration: number;
  description: string | undefined;
}

export interface ModuleItem {
  createdOn: string;
  lastUpdateOn: string;
  createdByName: string;
  createdByEmail: string;
  modifiedByName: string;
  modifiedByEmail: string;
  id: string;
  name: string;
  duration: number;
  subjectId: string;
  parentId: string;
  description: string;
  weight: number;
  type: string;
  searchKey: string;
}

export interface GetAllModulesResponse extends APIResponse {
  response: ModuleItem[];
}
export type AddModulesResponse = APIResponse;
export type UpdateModulesResponse = APIResponse;

export const ModuleApiSlice = createApi({
  reducerPath: "moduleApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllModules: builder.query<
      GetAllModulesResponse,
      { subjectId: string }
    >({
      query: ({ subjectId }) => ({
        url: `module/get?subjectId=${subjectId}`,
        method: "GET",
      }),
    }),
    addModules: builder.mutation<
      AddModulesResponse,
      { payload: AddModulePayload; subjectId: string }
    >({
      query: ({ subjectId, payload }) => ({
        url: `module/add?subjectId=${subjectId}`,
        method: "POST",
        body: payload,
      }),
    }),
    updateModule: builder.mutation<
      UpdateModulesResponse,
      { moduleId: string; payload: { [key: string]: string } }
    >({
      query: ({ moduleId, payload }) => ({
        url: `module?moduleId=${moduleId}`,
        method: "PUT",
        body: payload,
      }),
    }),
  }),
});

export const {
  useAddModulesMutation,
  useLazyGetAllModulesQuery,
  useUpdateModuleMutation,
} = ModuleApiSlice;
